export interface NavLink {
    label: string
    href: string
}

export interface Step {
    title: string
    description: string
}

export interface Faq {
    question: string
    answer: string
}

export const NAV_LINKS: Array<NavLink> = [
    { label: "Features", href: '/#features' },
    { label: "Phone sign-in", href: '/#phone-sign-in' },
    { label: "How it works", href: '/#how-it-works' },
    { label: "FAQ", href: '/#faq' }
]

export const BEFORE_ELENIX: Array<string> = [
    "Calling the sales team to find out which quotes went out",
    "Learning an item is out of stock when a customer asks for it",
    "No clear record of who used the system, or when"
]

export const WITH_ELENIX: Array<string> = [
    "Every quotation raised today, with its value, on your home screen",
    "Items running low flagged before they run out",
    "Every sign-in tied to a person, with alerts when something looks off"
]

export const STEPS: Array<Step> = [
    {
        title: "Book a demo",
        description: "Tell us about your business. We'll walk you through Elenix and answer your questions."
    },
    {
        title: "Add your team",
        description: "Each person is added with their mobile number and signs in with a PIN of their own."
    },
    {
        title: "Open Today every morning",
        description: "Quotations, sign-ins, low stock and alerts, waiting for you on one screen."
    }
]

export const FAQS: Array<Faq> = [
    {
        question: "What is Elenix?",
        answer: "Elenix is an ERP for growing businesses. It keeps your quotations, stock, team sign-ins and security alerts in one place, and opens on a Today screen that shows what's happening across the business."
    },
    {
        question: "Does my team need email addresses to use it?",
        answer: "No. Everyone signs in with their mobile number and a PIN, which makes Elenix easy to roll out to counter, warehouse and field staff who don't use email at work."
    },
    {
        question: "Can I use Elenix on my phone?",
        answer: "Yes. Elenix runs in your web browser, so it works on phones, tablets and computers with nothing to install."
    },
    {
        question: "How do I know who has been using it?",
        answer: "Each person signs in with their own mobile number and PIN, and the Today screen shows who signed in. Sign-in problems, such as repeated wrong PINs, show up as security alerts."
    },
    {
        question: "How do I get started?",
        answer: "Book a demo using the form on this page. We'll get in touch, learn how your business runs and walk you through Elenix."
    },
    {
        question: "I already use Elenix. Where do I sign in?",
        answer: "Use the Sign in button at the top of this page, then enter your mobile number and PIN."
    }
]

export const DEMO_POINTS: Array<string> = [
    "A guided walkthrough of Elenix",
    "Answers to your questions",
    "A clear picture of how your team would use it"
]
